export const VISIT_TYPE_IDS = {
  IMAGING_VISIT: "imaging",
  OFFICE_VISIT: "office-visit",
  PROCEDURE_VISIT: "procedure",
  CHIRO_VISIT: "chiro-visit",
  PT_VISIT: "pt-visit",
  ACUPUNCTURE_VISIT: "acupuncture-visit",
};

export enum MedChronVersionStatus {
  AI_REVIEWED = "ai_reviewed",
  UNDER_HUMAN_REVIEW = "under_human_review",
  HUMAN_REVIEWED = "human_reviewed",
}

export enum MedChronRequestStatus {
  TODO = "TODO",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/**
 * Resolve which visit types collapse from the (merged) template's `visitTypes`.
 * An empty set means no visit type collapses.
 * Keep in sync with Template.collapsible_visit_type_ids() in demanda/shared/infrastructure/repositories/templates/schemas/template.py.
 */
export function getCollapsibleVisitTypeIds(
  template?: { visitTypes?: Record<string, { collapsible?: boolean }> } | null
): Set<string> {
  const visitTypes = template?.visitTypes ?? {};
  return new Set(
    Object.entries(visitTypes)
      .filter(([, config]) => config?.collapsible)
      .map(([visitTypeId]) => visitTypeId)
  );
}

/** Chronology "visit type" group order: Imaging → Procedure → Medical (office); unlisted types sort after. */
const VISIT_TYPE_GROUP_SORT_RANK: Record<string, number> = {
  [VISIT_TYPE_IDS.IMAGING_VISIT]: 0,
  [VISIT_TYPE_IDS.PROCEDURE_VISIT]: 1,
  [VISIT_TYPE_IDS.OFFICE_VISIT]: 2,
};

const DEFAULT_VISIT_TYPE_GROUP_SORT_RANK = 3;

export function getVisitTypeGroupSortTier(visitTypeId: string): number {
  return VISIT_TYPE_GROUP_SORT_RANK[visitTypeId] ?? DEFAULT_VISIT_TYPE_GROUP_SORT_RANK;
}
